import { useContext } from 'react';
import { ProjectAccessibilityContext } from '../contexts';

export default () => useContext(ProjectAccessibilityContext);
